// extracted by mini-css-extract-plugin
module.exports = {"InvitationPage":"InvitationPage_InvitationPage__1imdP","imageContainer":"InvitationPage_imageContainer__2JQtn","buttons":"InvitationPage_buttons__1yE4E"};